// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__Rqu9i","title":"SectionHeader_title__a_HPA"};